"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _theme = _interopRequireDefault(require("../../theme"));

var _CarvanaHeaderSkeleton = require("./CarvanaHeaderSkeleton.styles");

var _HeaderMenu = _interopRequireDefault(require("./HeaderMenu/HeaderMenu"));

var _Mobile = _interopRequireDefault(require("./HeaderMenu/Mobile"));

var _Navigation = _interopRequireDefault(require("./Navigation"));

var _Logo = _interopRequireDefault(require("./Logo"));

var _Partner = _interopRequireDefault(require("./Partner"));

var _Covid19Banner = _interopRequireDefault(require("./Covid19Banner"));

var _ApplicationSettings = _interopRequireDefault(require("./services/ApplicationSettings"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var _ref = _react.default.createElement(_Covid19Banner.default, null);

var _ref2 = _react.default.createElement(_Logo.default, null);

var _ref3 = _react.default.createElement(_CarvanaHeaderSkeleton.MobileLogo, null);

var CarvanaHeaderSkeleton = function (_PureComponent) {
  _inherits(CarvanaHeaderSkeleton, _PureComponent);

  function CarvanaHeaderSkeleton(props) {
    var _this;

    _classCallCheck(this, CarvanaHeaderSkeleton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CarvanaHeaderSkeleton).call(this, props));
    var environment = _this.props.environment;

    _ApplicationSettings.default.setEnvironment(environment);

    _this.state = {
      activeMenuName: null
    };
    return _this;
  }

  _createClass(CarvanaHeaderSkeleton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          environment = _this$props.environment,
          partner = _this$props.partner,
          screenHeight = _this$props.screenHeight,
          shouldShowCovid19Banner = _this$props.shouldShowCovid19Banner;
      var activeMenuName = this.state.activeMenuName;
      var hasPartner = partner && partner.shouldHidePartnerHeaderBanner !== undefined;
      var shouldShowPartnerBanner = hasPartner && !partner.shouldHidePartnerHeaderBanner;
      return _react.default.createElement(_styledComponents.ThemeProvider, {
        theme: _theme.default,
        "data-qa": "carvana-header-skeleton"
      }, _react.default.createElement(_CarvanaHeaderSkeleton.HeaderWrapper, {
        "data-cv-test": "headerWrapper"
      }, shouldShowCovid19Banner && _ref, _react.default.createElement(_CarvanaHeaderSkeleton.NavigationWrapper, null, _react.default.createElement(_Navigation.default, {
        environment: environment
      }), shouldShowPartnerBanner ? _react.default.createElement(_Partner.default, {
        partner: partner
      }) : null), _react.default.createElement(_CarvanaHeaderSkeleton.HeaderMenuWrapper, null, _ref2, _react.default.createElement(_HeaderMenu.default, {
        partner: partner,
        activeMenuName: activeMenuName
      })), _react.default.createElement(_CarvanaHeaderSkeleton.HeaderMenuMobileWrapper, null, _ref3, _react.default.createElement(_Mobile.default, {
        screenHeight: screenHeight,
        partner: partner
      }))));
    }
  }]);

  return CarvanaHeaderSkeleton;
}(_react.PureComponent);

CarvanaHeaderSkeleton.defaultProps = {
  environment: 'development',
  partner: {},
  shouldShowCovid19Banner: false
};
var _default = CarvanaHeaderSkeleton;
exports.default = _default;
module.exports = exports.default;